import { useEffect, useRef, useState } from 'react';
import { useNavigate, useSearchParams, Link as RouterLink } from 'react-router';
import { Alert, Box, Card, CircularProgress, Link, Stack, Typography } from '@mui/joy';

import { APIBusinessVerifyEmail } from '../../api_business_auth';
import { useAdvertiser } from '../../AdvertiserContext';

export default function BusinessVerifyEmailPage() {
    const navigate = useNavigate();
    const [params] = useSearchParams();
    const token = params.get('token') || '';
    const { applyLoginSuccess } = useAdvertiser();

    const [state, setState] = useState('loading'); // loading | ok | error
    const [message, setMessage] = useState('');
    const once = useRef(false);

    useEffect(() => {
        if (once.current) return;
        once.current = true;
        if (!token) { setState('error'); setMessage('Ссылка недействительна'); return; }
        (async () => {
            try {
                const res = await APIBusinessVerifyEmail(token);
                if (res?.token) {
                    applyLoginSuccess(res.token, res.advertiser);
                    navigate('/business');
                    return;
                }
                setState('ok');
            } catch (e) {
                setState('error');
                setMessage(e?.response?.data?.error || 'Не удалось подтвердить email');
            }
        })();
    }, [token, applyLoginSuccess, navigate]);

    return (
        <Box sx={{ minHeight: '100vh', display: 'flex', justifyContent: 'center', alignItems: 'center', px: 2 }}>
            <Card sx={{ p: 3, borderRadius: 'xl', boxShadow: 'lg', maxWidth: 420, width: '100%', textAlign: 'center' }}>
                {state === 'loading' && (
                    <Stack alignItems="center" spacing={1.5}>
                        <CircularProgress />
                        <Typography level="body-sm" color="neutral">Подтверждаем email…</Typography>
                    </Stack>
                )}
                {state === 'ok' && (
                    <Alert color="success">
                        Email подтверждён. <Link component={RouterLink} to="/business/login">Войти в кабинет</Link>
                    </Alert>
                )}
                {state === 'error' && <Alert color="danger">{message}</Alert>}
            </Card>
        </Box>
    );
}